import { useState } from "react";
import { toast } from "react-hot-toast";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import API from "../Network/API";
import { useDispatch, useSelector } from "react-redux";
import isTenantUser from "../CustomHook/tenantUser";
import { useRef } from "react";
import { LOCK_ALARM_HISTORY_EDIT_SUCCESS } from "../Reducer/LockAlarmHistorySlice";
import { ACS_ACTIVE_ALARM_HISTORY_EDIT_SUCCESS } from "../Reducer/AcsActiveAlarmSlice";

export default function AcknowledgmentModel(props) {
    const [loading, setLoading] = useState(false);
    const modalRef1 = useRef()
    const dispatch = useDispatch();
    const { user: profileUser } = useSelector((state) => state.profileReducer);
    const { user: authUser } = useSelector((state) => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);


    const mode = props?.mode || 'default';
    const isClearMode = mode === 'clear';
    const isAckMode = mode === 'ack';

    const getRequestType = (event) => {
        if (isClearMode) {
            return 1;
        }
        if (isAckMode) {
            return 2;
        }
        if (props?.alarm?.alarm_type == 1 || props?.alarm?.alarm_type == 6) {
            return 1;
        }
        return event.target.requst_type.checked ? 1 : 2;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (tenantUser) {
            toast.error('You are not allowed to acknowledge or clear alarms');
            return;
        }
        setLoading(true)
        const fd = new FormData();
        if (event.target.remark.value == '') {
            toast.error('remark was required')
            setLoading(false)
            return 0;
        }

        fd.append(`id`, props?.alarm?.id)
        fd.append(`remark`, event.target.remark.value)
        fd.append(`alarm_type`, props.type)
        fd.append('request_type', getRequestType(event))

        API.post('/v1/oauth/acknowledgments/store', fd)
            .then(response => {
                setLoading(false);
                dispatch(LOCK_ALARM_HISTORY_EDIT_SUCCESS(response.data.data))
                dispatch(ACS_ACTIVE_ALARM_HISTORY_EDIT_SUCCESS(response.data.data))
                props.handleShowB();
                document.getElementById("add_country_form").reset()
                toast.success(response.data.message);
                if (typeof props.onSuccess === 'function') {
                    props.onSuccess(response.data.data);
                }
            }).catch((error) => {
                setLoading(false);
                toast.error(error.response.data.message)
            });
    }
    return (
        <>
            <Modal
                isOpen={props.isModalVisible}
                size=""
                toggle={props.handleShowB}
                className={'modal-dialog-scrollable popup-max-height'} backdrop="static"
                ref={modalRef1} >
                <ModalHeader toggle={props.handleShowB} id={'staticBackdropLabel'}>
                    {isClearMode ? 'Alarm Clear' : 'Acknowledgment'} ({props?.alarm?.site_id})
                </ModalHeader>
                <ModalBody className="bg-light">
                    <div className="meeting-schedule-popup">
                        <form onSubmit={handleSubmit} id="add_country_form">
                            <div className="row mb-3">
                                <div className={`col-12 mb-2`}>
                                    <label htmlFor="i_Friends" className="form-label form-label-font-14">Alarm Name</label>
                                    <input disabled type="text" className="rounded-0 form-control" value={props?.alarm?.name} />
                                </div>
                                <div className={`col-12 mb-2`}>
                                    <label htmlFor="i_Friends" className="form-label form-label-font-14">Remark <em className="text-danger">*</em></label>
                                    <textarea required type="text" className="rounded-0 form-control" name="remark" />
                                </div>

                                <div className={`col-12 mb-2 ${(props?.alarm?.alarm_type==1 || props?.alarm?.alarm_type==6 || isAckMode || isClearMode)?'d-none':''}`}>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" name="requst_type" />
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Close This Alarm?</label>
                                    </div>
                                </div>


                            </div>
                            <ModalFooter className={'post-footer-comment-icon bg-light'}>

                                <button type="submit" className="btn bg-success text-white rounded-pill"><i class="fa-light fa-save me-1"></i> Submit{loading ? (
                                    <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span>
                                ) : (
                                    <span></span>
                                )}</button>

                            </ModalFooter>
                        </form>
                    </div>

                </ModalBody>
            </Modal>
        </>
    )
}